import { render, staticRenderFns } from "./PrivacyPolicyIndia.vue?vue&type=template&id=4af5ea6c&scoped=true"
import script from "./PrivacyPolicyIndia.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyIndia.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyIndia.vue?vue&type=style&index=0&id=4af5ea6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af5ea6c",
  null
  
)

export default component.exports